<template>
  <section class='content'>
    <!--<template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i :class="alert.icon"></i>
          {{'alert_'+alert.type | translate}}!</h4>
        {{alert.message}}
      </b-alert>
    </template>-->
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">Error Logs</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse">
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-xs-12">
            <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
          </div>
        </div>
      </div>
      <div class="box-body">
      <div v-if="pagination.data.length > 0" class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>ID</th>
            <th>{{'date' | translate}}</th>
            <th>{{'type' | translate}}</th>
            <th>{{'download' | translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item, index in pagination.data">
            <td>{{ item.id}}</td>
            <td class="small">{{item.created_at | orderDate}}<i class="fa fa-clock-o mr-5 ml-5"></i>{{item.created_at | orderDate(true)}}</td>
            <td>{{item.type}}</td>
            <td>
              <a class="btn btn-success" target="_blank" :href="item.path"><i class="fa fa-cloud-download mr-5"></i>{{'download' | translate}}</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <div class="callout callout-info">
          <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
          <p>Es sind keine Error Logs vorhanden</p>
        </div>
      </div>
    </div>
    </div>
  </section>
</template>
<script>
import MonitoringComponent from '../../tools/MonitoringComponent.vue'
import MonitoringTableComponent from '../../tools/Tables/MonitoringTableComponent.vue'

export default {
  data () {
    return {
      logs: {},
	    pagination: {
          total: 0,
          per_page: 25,
          current_page: 1,
          total_pages: 0,
          data: []
	    },
      alerts: []
    }
  },
  components: {
  },
  methods: {
  },
  mounted () {
    API.get('monitoring/error/logs', {})
      .then(response => {
        this.pagination = response.data
      })
  }
}
</script>
<style scoped>
  .loading-gif {
    display: block;
    width: 5%;
    top: 42%;
    left: 50%;
    position: fixed;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/Monitoring/Logs.vue